import _BaseAPIService from "../_BaseAPIService";

const apiService = _BaseAPIService.instance;

const NewsService = {
  // Define your API functions here
  create: async (data) => {
    const response = await apiService.post("/news", data);
    return response.data;
  },
  update: async (id, updatedData) => {
    try {
      const response = await apiService.put(`/news/${id}`, updatedData);
      return response.data;
    } catch (error) {
      console.error("Error updating ratecard:", error);
      throw error;
    }
  },
  getList: async () => {
    // const params = new URLSearchParams({
    //   ...(search && { search }),
    //   page: page.toString(),
    //   pageSize: pageSize.toString(),
    // });

    const response = await apiService.get(`/news`);
    return response.data;
  },
  getDetail: async (id) => {
    const response = await apiService.get(`/news/${id}`);
    return response.data;
  },

  delete: async (id) => {
    const response = await apiService.delete(`/news/${id}`);
    return response.data;
  },
};

export default NewsService;
